import React from 'react'
import { connect } from 'react-redux'
import styles from './Contraindications.module.css';
import { bindActionCreators } from 'redux';
import { patientActions } from '_actions'

class PatientHomeAdmissionContraindications extends React.Component {

    constructor() {
        super();
        this.handleContrainChange = this.handleContrainChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.saveContrain = this.saveContrain.bind(this);
        this.state = {
            contrain: "",
            changingTimeout: 0,
            hasChanges: false
        };
    }

    componentDidMount() {
        this.setState((state) => {
            return { contrain: this.props.contrain ? this.props.contrain.trim() : '' };
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.ptno !== prevProps.ptno ||
            this.props.contrain !== prevProps.contrain) {
            this.setState((state) => {
                return { contrain: this.props.contrain ? this.props.contrain.trim() : '', hasChanges: false };
            })
        }
    }

    handleContrainChange(event) {
        if (this.state.changingTimeout) {
            clearTimeout(this.state.changingTimeout);
        }

        this.setState({
            contrain: event.target.value,
            hasChanges: true,
            changingTimeout: setTimeout(() => this.saveContrain(), 2000)
        });
    }

    saveContrain() {
        if (this.state.hasChanges) {
            this.props.updateContrain(this.props.epno, this.state.contrain);
            this.setState({ hasChanges: false });
        }
    }

    handleOnBlur() {
        this.saveContrain();
        clearTimeout(this.state.changingTimeout);
    }

    render() {
        return (
            <div>
                <div className={styles.contrain_header}>Contraindications</div>
                <div className={styles.contrain_input}>
                    <textarea name="patientContrain" type="text" className={styles.contrain} rows="6" value={this.state.contrain} onChange={this.handleContrainChange} onBlur={this.handleOnBlur} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        ptno: state.ui.patients.selectedPtno,
        contrain: state.entities.admissions[ownProps.epno].contraindications
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateContrain: bindActionCreators(patientActions.updateAdmissionContrain, dispatch)
    };
}


const connectedPatientHomeAdmissionContraindications = connect(mapStateToProps, mapDispatchToProps)(PatientHomeAdmissionContraindications);
export { connectedPatientHomeAdmissionContraindications as PatientHomeAdmissionContraindications };
